// 获取视频列表
export const GETVIDEOLIST = 'get-video-list'
// 获取视频详情
export const GETVIDEOCONTEXT = 'get-video-context'
// 获取 根据标签 推荐视频
export const GETVIDEOLISTBYTAGS = 'get-video-list-by-tags'
// 获取推荐视频
export const GETVIDEORECOMMENDLIST = 'get-video-recommend-list'
